<template>
  <div class="flex items-center space-x-3">
    <div class="flex-shrink-0">
      <div
        class="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center"
      >
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          ></path>
        </svg>
      </div>
    </div>
    <div class="flex-1">
      <p class="text-sm font-medium text-white">
        Attendance marked for {{ formatTodaysDate() }}
      </p>
      <p class="text-xs text-emerald-100 mt-1">
        {{ getDayName() }}
      </p>
    </div>
  </div>
</template>

<script setup>
  // Helper function to format today's date
  const formatTodaysDate = () => {
    const today = new Date();
    return today.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Helper function to get day name
  const getDayName = () => {
    const today = new Date();
    return today.toLocaleDateString("en-US", { weekday: "long" });
  };
</script>
